<template>
  <div>
      <a-row>
        <g-master name="forms"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :actions ="false"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :parentData="parentData"
                  ref="master"
        >
        </g-master>
      </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'social_security_hist',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Tipo de entidad', dataIndex: 'ent_type_desc', sorter: true},
              {title: 'ID entidad', dataIndex: 'ent_id_name', sorter: true},
              {title: 'Cobertura', dataIndex: 'cob', sorter: true},
              {title: 'Fecha desde', dataIndex: 'since_date_desc', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Fecha de edición', dataIndex: 'modified_on', sorter: true}
            ]
          }
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    },
    methods: {
      consultarDatos () {
        this.$refs.master.$refs.datatable.loadData()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeSocialSecurityHist.vue